<div>
  <span
    class="notification-item-date d-flex"
    *ngIf="
      index === 0 ||
      notificationData.displayDate !== previousNotification?.displayDate
    "
    >{{ notificationData.displayDate }}</span
  >
  <div
    class="item-wrapper"
    [ngClass]="{
      unread: notificationData.recipient && !notificationData.recipient.read_at
    }"
    (click)="openNotification()"
    (keydown)="openNotification()"
  >
    <div class="notification-content d-flex">
      <img
        src="../../../../assets/icons/svg/notification-mail.svg"
        alt="file"
        class="me-3 mt-1"
        height="25"
        width="25"
      />
      <div class="d-flex flex-column w-100">
        <p class="mb-0">
          {{ notificationData.title }}
        </p>
        <p class="m-0" [innerHtml]="notificationData.body"></p>
        <ng-container
          *ngIf="
            notificationData.source_type == 'CHAT' ||
            notificationData.source_type == 'DATASET'
          "
        >
          <span class="hyperlink-text">Click here to view</span>
        </ng-container>
      </div>
      <div
        [matMenuTriggerFor]="menu"
        (click)="$event.stopPropagation()"
        (keydown)="$event.stopPropagation()"
        class="d-flex align-self-center ms-auto view-more-icon"
      >
        <img
          src="../../../../assets/icons/svg/more-vertical.svg"
          class="action-i"
          alt="more"
          height="19"
          width="15"
        />
        <mat-menu
          #menu="matMenu"
          class="notification-menu"
          xPosition="before"
          yPosition="below"
        >
          <button
            mat-menu-item
            (click)="markAsRead()"
            *ngIf="
              notificationData.recipient && !notificationData.recipient.read_at
            "
          >
            <img
              src="../../../../assets/icons/svg/check.svg"
              alt="check"
              height="25"
              width="24"
            /><span class="ms-2 notification-menu-text">Mark as read</span>
          </button>

          <button mat-menu-item (click)="deleteNotification()">
            <img
              src="../../../../assets/icons/svg/garbage-delete.svg"
              alt="Delete"
              height="19"
              width="24"
            /><span class="ms-2 delete-text notification-menu-text"
              >Delete this notification</span
            >
          </button>
        </mat-menu>
      </div>
    </div>
  </div>
</div>
